import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import Modal from "react-modal";
import moment from "moment-timezone";
import FetchUserDetails from "../payment-link-system/FetchUserDetails";
import { registerUser } from "../../redux/reducers/postApiSlice";
import { showConfirmAlert } from "../components-react/ReactAlert";
import { validatemap_form_email } from "../../exports/Validations";
import { fetchUserDetailsByMobileData } from "../../redux/reducers/apiSlice";
import DFPaymentLinkForm from "./DFPaymentLinkForm";
import { useUpdateForm } from "../../data/Queries";
import { usersGetKey, userUpdate } from "../../data/ApiEndpoints";
import DPForm from "../discount-payments/DPForm";

const UserDetails = ({
  decryptedText,
  callFunction,
  showUserInfoForm,
  setShowUserInfoForm,
  pageName,
}) => {
  const dispatch = useDispatch();
  const { userDetailsByMobile } = useSelector((state) => state.api);
  const { mutateAsync: updateUser, isLoading: isLoadingUser } = useUpdateForm({
    url: userUpdate,
    key: usersGetKey,
    token: decryptedText?.token,
  });

  const initialUserFormData = {
    mobile: "",
    email: "",
    name: "",
    gender: "",
    user_id: "",
    dob: "",
  };
  const [userFormData, setUserFormData] = useState(initialUserFormData);
  const [isUserExist, setIsUserExist] = useState(false);
  const [isFetchUserDetaillsByMobile, setIsFetchUserDetaillsByMobile] =
    useState(false);
  const [paymentFormModal, setPaymentFormModal] = useState(false);
  const [isUpdateRequired, setIsUpdateRequired] = useState(null);

  const handleModCloseEvent = () => {
    setPaymentFormModal(false);
    setUserFormData(initialUserFormData);
  };

  const onClickFetchUserDetails = () => {
    if (userFormData.mobile && userFormData.mobile?.length === 10) {
      const handleConfirm = () => {
        dispatch(
          fetchUserDetailsByMobileData({
            userMobile: userFormData.mobile,
            token: decryptedText?.token,
          })
        );

        setIsFetchUserDetaillsByMobile(true);
      };

      showConfirmAlert(
        handleConfirm,
        `Is the entered ${userFormData.mobile} number correct?`
      );
    } else {
      toast.error("Please Enter Mobile Number! (Number Must Be 10 Digit)");
      setIsFetchUserDetaillsByMobile(false);
    }
  };

  const onClickRegisterUser = (isUpdateRequired) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const nameRegex = /^[A-Za-z\s]+$/;
    const yopmailRegex = /@yopmail\.com$/i;
    const mobileRegex = /^\d{10}$/;
    const today = moment().tz("Asia/Kolkata").startOf("day");

    if (
      !userFormData.mobile ||
      !userFormData.email ||
      !userFormData.name ||
      !userFormData.gender?.value ||
      !userFormData.dob
    ) {
      toast.error("Please Ensure All The Fields Are Filled!");
      return;
    }

    if (!nameRegex.test(userFormData.name)) {
      toast.error("Name should only contain letters!");
      return;
    }

    if (!emailRegex.test(userFormData.email)) {
      toast.error("Please Enter Correct Format of Email!");
      return;
    }

    if (yopmailRegex.test(userFormData.email)) {
      toast.error("Yopmail is not allowed!");
      return;
    }

    if (!mobileRegex.test(userFormData.mobile)) {
      toast.error("Please Enter Correct Format of Mobile Number!");
      return;
    }

    if (userFormData.dob) {
      const enteredDOB = moment
        .tz(userFormData.dob, "Asia/Kolkata")
        .startOf("day");
      const age = today.diff(enteredDOB, "years");

      if (enteredDOB.isAfter(today)) {
        toast.error("DOB cannot be in the future!");
        return;
      } else if (age < 10) {
        toast.error("Member must be at least 10 years old!");
        return;
      }
    }

    const userData = {
      uid: isUpdateRequired ? userFormData?.uid : "",
      name: userFormData.name,
      mobile: userFormData.mobile,
      email: userFormData?.email,
      gender: userFormData.gender?.value,
      dob: userFormData.dob || "",
      is_web: 1,
      account_type: "member",
      otp: "otp",
      referral_code: "",
      n_token: "n_token",
    };

    if (isUpdateRequired) {
      handleUpdateUser(userData);
    } else {
      handleRegisterUser(userData, decryptedText?.token);
    }
  };

  async function handleUpdateUser(userData) {
    async function handleUpdateUserConfirm() {
      try {
        const formdata = new FormData();

        Object.entries(userData).forEach(([key, value]) => {
          formdata.append(key, value);
        });

        const { status, message, data } = await updateUser({ data: formdata });
        // const result = await updateUser({ data: formdata });

        console.log("result=> ", data);

        if (status) {
          toast.success(message);
          setUserFormData(data[0]);
          setPaymentFormModal(true);
          setShowUserInfoForm(false);
          setIsUserExist(false);
          setIsUpdateRequired(null);
        } else {
          toast.error(message);
        }
      } catch (error) {
        console.log(error);
      }
    }

    showConfirmAlert(
      handleUpdateUserConfirm,
      `Are you sure you want to update the user details?`
    );
  }

  function handleBack() {
    setUserFormData(initialUserFormData);
    setIsUserExist(false);
    setIsFetchUserDetaillsByMobile(false);
    setIsUpdateRequired(null);
  }

  const handleRegisterUser = async (userData, TOKEN) => {
    try {
      const actionResult = dispatch(registerUser({ userData, TOKEN }));
      const result = await actionResult;

      if (result?.payload?.status && result?.payload?.data) {
        setUserFormData(result.payload.data);
        setPaymentFormModal(true);
        setShowUserInfoForm(false);
        setIsUserExist(false);
        setIsUpdateRequired(null);
      } else {
        const errorMessage = result?.payload?.message || result?.error?.message;
        toast.error(errorMessage);
      }
    } catch (error) {
      console.log("handleRegisterUser ERROR => ", error);
    }
  };

  useEffect(() => {
    if (isFetchUserDetaillsByMobile && userDetailsByMobile?.status) {
      const { email, gender, account_type } = userDetailsByMobile?.data?.[0];

      const isEmailInvalid = !validatemap_form_email(email);
      const isGenderMissing = !gender;

      if (account_type !== "member") {
        toast.error(
          `This Mobile Number does not belong to a member. It's a ${account_type} account!`
        );
        return;
      }
      // else if (pageName === "dp" && gender === "male") {
      //   toast.error(
      //     "Male customers are not allowed to avail this offer; it is applicable only for females. To send the link for a non-female customer, kindly navigate to the Deferred Payment section."
      //   );
      //   return;
      // }
      else if (isEmailInvalid || isGenderMissing) {
        setIsUpdateRequired({
          isEmailRequired: !validatemap_form_email(email) ? email : false,
          isGenderRequired: !gender ? true : false,
        });
        setUserFormData(userDetailsByMobile?.data?.[0]);

        let errorMessage = "Please update the following fields: ";
        if (isEmailInvalid) errorMessage += "Email ";
        if (isEmailInvalid && isGenderMissing) errorMessage += "and ";
        if (isGenderMissing) errorMessage += "Gender.";

        toast.error(errorMessage);
        // toast.error("Member Email Is Not Valid! Please Update Email.");
        // return;
      } else {
        setUserFormData(userDetailsByMobile?.data?.[0]);
        setPaymentFormModal(true);
        setShowUserInfoForm(false);
        setIsUserExist(false);
        setIsUpdateRequired(null);
      }
    } else if (
      isFetchUserDetaillsByMobile &&
      userDetailsByMobile?.status === false
    ) {
      setIsUserExist(true);
      toast.error(userDetailsByMobile?.message);
    }
  }, [userDetailsByMobile]);

  useEffect(() => {
    if (paymentFormModal) {
      setShowUserInfoForm(false);
    }

    if (!showUserInfoForm && !paymentFormModal) {
      setUserFormData(initialUserFormData);
    }
  }, [paymentFormModal, showUserInfoForm]);

  // console.log("userFormData=> ", userFormData);

  return (
    <>
      <Modal
        isOpen={paymentFormModal}
        onRequestClose={handleModCloseEvent}
        contentLabel="Form Modal"
        ariaHideApp={false}>
        <div className={`createNewCTOModalContainer`}>
          {pageName === "dp" ? (
            <DPForm
              userInfoData={decryptedText}
              closeModal={handleModCloseEvent}
              callFunction={callFunction}
              rowData={userFormData}
            />
          ) : (
            <DFPaymentLinkForm
              userInfoData={decryptedText}
              closeModal={handleModCloseEvent}
              callFunction={callFunction}
              rowData={userFormData}
            />
          )}
        </div>
      </Modal>

      {showUserInfoForm && (
        <FetchUserDetails
          isUserExist={isUserExist}
          userFormData={userFormData}
          setUserFormData={setUserFormData}
          onClickFetchUserDetails={onClickFetchUserDetails}
          onClickRegisterUser={onClickRegisterUser}
          handleBack={handleBack}
          isUpdateRequired={isUpdateRequired}
        />
      )}
    </>
  );
};

export default UserDetails;
